<template>
  <div class="works-component jade">
    <div class="banner"> 
      <img src="../../../assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/00-hero banner.jpg" alt="">
    </div>
    <div class="border-bottom-white-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 white text-left m-0">
          青禾 | Jade
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-white-1px"> 
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/01-landscape-living-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(0)" > 
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/01-landscape-living-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(1)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/01-landscape-living-03.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(2)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/02-landscape-dining-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(3)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/02-landscape-dining-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(4)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/03-full-dining-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(5)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/04-portrait-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(6)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/04-portrait-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(7)" >
        </b-col> 
      </b-row> 
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/05-landscape-master-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(8)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/05-landscape-master-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(9)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/05-landscape-master-03.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(10)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/06-portrait-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(11)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/06-portrait-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(12)" >
        </b-col>
      </b-row>  
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="Blue"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left_white.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 white  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 white p-0">蓝色小时 | Blue</p>
              <p class="inter inter-body-md-400 white p-0">Eco Majestic Mellowood</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 white  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 white p-0">色彩生活 | Colours</p>
              <p class="inter inter-body-md-400 white p-0">Semanja Kajang | Kajang</p>
            </b-col>
            <b-col cols="3"  to="Colours"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right_white.svg" alt=""></b-col>
          </b-row>
          
        </b-col>
      </b-row>
    </div>
    <GlobalLightbox
      :visible.sync="lightboxVisible"
      :images="resolvedImages"
      :index="currentIndex"
    />
  </div>

</template>

<script>
import GlobalLightbox from "@/components/GlobalLightbox.vue";
export default {
  name: 'jadeLinkHouse',
  components: { GlobalLightbox },
  data() {
    return { 
      basePath: "@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG",
      images: [ 
        "01-landscape-living-01.jpg", 
        "01-landscape-living-02.jpg", 
        "01-landscape-living-03.jpg", 
        "02-landscape-dining-01.jpg", 
        "02-landscape-dining-02.jpg", 
        "03-full-dining-01.jpg", 
        "04-portrait-01.jpg", 
        "04-portrait-02.jpg", 
        "05-landscape-master-01.jpg", 
        "05-landscape-master-02.jpg", 
        "05-landscape-master-03.jpg",  
        "06-portrait-01.jpg", 
        "06-portrait-02.jpg"
    ],
      lightboxVisible: false,
      currentIndex: 0
    }
  },
  computed: {
    resolvedImages() {
     return this.images.map(img => 
      require(`@/assets/img/works/link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/${img}`)
    );
  }
  },
  methods: { 
    showLightbox(index) {
      this.currentIndex = index;
      this.lightboxVisible = true;
    }
  },  

}
</script>

<style>
 
.jade{
  background-color: #4D6B67 !important;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.jade p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}

@media (max-width: 576px) { 
}
</style>